export default {"src":"/_next/static/media/money-flying.dc3d501e.svg","height":234,"width":247};